// @flow

import type { Action } from 'app/common/redux/types';

export type State = {
  recentSaves: Array<{ boardId: string }>,
  recentUpsell: { [string]: number },
};

const defaultState = {
  recentSaves: [],
  recentUpsell: {},
};

const postRepinMoreIdeasUpsell = (state?: State = defaultState, action: Action): State => {
  switch (action.type) {
    case 'PIN_BETTER_SAVE': {
      const { localPinId, boardId } = action.payload;
      if (!localPinId) {
        // ignore optimistic save
        return state;
      }
      return {
        ...state,
        recentSaves: [{ boardId }, ...state.recentSaves],
      };
    }
    case 'POST_REPIN_MORE_IDEAS_UPSELL_SHOWN': {
      const { boardId } = action.payload;
      return {
        ...state,
        recentUpsell: {
          ...state.recentUpsell,
          [boardId]: Date.now(),
        },
      };
    }
    default:
      return state;
  }
};

export default postRepinMoreIdeasUpsell;
